import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      marginBottom: spacing(4),
    },
    cardHeader: {
      marginBottom: spacing(5),
    },
    cardTitle: {
      fontSize: 18,
      color: colors.black.darker,
      fontWeight: 500,
    },
    oneColumnGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: spacing(4),
      width: '100%',
      marginBottom: spacing(4),
    },
    twoColumnGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: spacing(4),
      width: '100%',
      marginBottom: spacing(4),
    },
    fullWidth: {
      gridColumn: '1 / -1',
    },
    fullWidthRentRate: {
      gridColumn: '1 / -1',
      marginBottom: spacing(4),
    },
    itemsLine: {
      width: '100%',
      marginBottom: spacing(6),
      gap: spacing(4),
      alignItems: 'flex-end',
    },
    leaseLength: {
      display: 'flex',
      gap: spacing(4),
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      width: '100%',
    },
    itemsGap: {
      gap: spacing(4),
    },
    notInScheduleSelect: {
      width: `calc(50% - ${spacing(2)}px)`,
    },
    subheaderText: {
      fontSize: 14,
      color: colors.black.darkest,
    },
    radioGroupControl: {
      marginBottom: 0,
    },
    radioGroup: {
      flexDirection: 'row',
      flexWrap: 'nowrap',
      marginTop: spacing(3),
    },
    radioGroupLabel: {
      fontSize: 14,
      fontWeight: 500,
      color: colors.kato.neutral[900],
      paddingTop: 0,
    },
    label: {
      fontSize: 14,
      fontWeight: 500,
      color: `${colors.kato.neutral[900]}`,
      marginBottom: spacing(2),
    },
    currencyAdornment: {
      color: colors.kato.neutral[500],
      paddingRight: spacing(2),
    },
    periodAdormnent: {
      paddingLeft: spacing(2),
      paddingTop: spacing(0.75),
    },
    leaseEndInfo: {
      fontSize: 14,
      fontWeight: 500,
      color: colors.kato.neutral[900],
      marginBottom: spacing(4),
    },
    numberField: {
      flex: 1,
    },
    select: {
      backgroundColor: colors.white.lightest,
    },
    rootSelect: {
      width: '100%',
    },
    datePicker: {
      '& .MuiOutlinedInput-adornedStart': {
        width: '100%',
      },
    },
    divider: {
      backgroundColor: colors.grey.light,
      height: 1,
      width: '100%',
      margin: spacing(4, 0),
    },
    defaultText: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 14,
      fontWeight: 500,
      color: colors.grey.darker,
    },
    changeAssigneeBtn: {
      fontSize: 14,
      marginLeft: spacing(1),
      cursor: 'pointer',

      '&:hover': {
        color: colors.blue.darkish,
      },
    },
    userAutocomplete: {
      marginBottom: spacing(5),
    },
    rootSelectLeaseType: {
      width: '100%',
      marginTop: '6px !important',
    },
    rootMetricSelect: {
      display: 'flex',
      justifyContent: 'end',
    },
  });
